/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import Image from 'next/image';
import CourseSection from './course-description';
import CourseTestSection from './course-test-section/course-test-section';
import TestimonialSection from './testimonial-section';
import CourseFeatures from './course-features';
import CourseSpecifications from './course-specifications';
import CourseBatchSection from './batch-section/course-batch-section';
import FAQSectionMinimal from './faqs';
import CarouselSection from './carousel';
import NoDataFound from '../shared/DataNotFound';

function CourseLanding({ initialCourseGroupData }) {
  if (!initialCourseGroupData) {
    return <NoDataFound />;
  }

  const contentBlocks = initialCourseGroupData?.contentBlocks || [];

  useEffect(() => {
    const fragment = window.location.hash.replace('#', '');
    if (fragment === '2-year-elevate') {
      const timer = setTimeout(() => {
        const buttonId = `${fragment}-btn`;
        const buttons = document.querySelectorAll(`button[id="${buttonId}"]`);
        console.log('Buttons found for fragment:', buttons);
        buttons.forEach((button) => {
          button.click();
        });
      }, 2500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      window.location.reload();
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="w-full bg-gray-50 flex flex-col justify-center items-center gap-[16px] md:gap-[34px]">
      {initialCourseGroupData?.meta?.headHtml && (
        <div
          className="w-full px-5 md:px-[52px]"
          dangerouslySetInnerHTML={{
            __html: initialCourseGroupData?.meta?.headHtml,
          }}
        />
      )}
      {initialCourseGroupData?.banner && (
      <div className="w-full px-5 md:px-[52px]">
        <div className="flex justify-center">
          <img
            src={initialCourseGroupData?.banner}
            alt={initialCourseGroupData?.bannerAlt}
            fetchPriority="high"
            decoding="async"
          />
        </div>
      </div>
      )}
      <div className="w-full mx-auto flex flex-col justify-start items-center gap-0 md:gap-[10px]">
        {/* {initialCourseGroupData?.banner && (
          <div className="w-full px-5 md:px-[52px]">
            <div className="relative aspect-[1336/450] w-full md:h-[450px]">
              <Image
                src={initialCourseGroupData?.banner}
                alt={initialCourseGroupData?.bannerAlt}
                fill
                className="object-cover"
                priority
              />
            </div>
          </div>
        )} */}
        {/* {
          courseGroupData?.supportedLanguages.length > 1
          && (
          <div className="w-full max-w-[1380px] mx-auto px-4 sm:px-6 lg:px-8 flex justify-end">
            <div className="relative w-full sm:w-52">
              <button
                type="button"
                onClick={() => setIsLanguageOpen((prev) => !prev)}
                className="flex items-center justify-between w-full px-3 sm:px-4 py-2 sm:py-[10px] bg-white border border-thinBlue rounded-lg shadow-sm"
              >
                <span className="text-gray-700 text-xs sm:text-sm max-w-[150px] truncate block">{selectedLanguage === 'en' ? 'English' : 'हिंदी'}</span>
                <svg width="14" height="7" viewBox="0 0 14 7" className={` text-customBlue transition-transform ${isLanguageOpen ? 'rotate-180' : ''}`} fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.707108 1.09218C0.316607 1.41761 0.316607 1.94527 0.707107 2.27069L5.59941 6.34352C6.3805 6.99386 7.6463 6.99361 8.4271 6.34302L13.3175 2.26769C13.708 1.94227 13.708 1.41461 13.3175 1.08917C12.9269 0.763732 12.2938 0.763732 11.9032 1.08917L7.7176 4.57719C7.3271 4.90269 6.6939 4.90269 6.3034 4.57719L2.12131 1.09218C1.73081 0.76674 1.09771 0.76674 0.707108 1.09218Z" fill="#217ABB" />
                </svg>
              </button>
              {isLanguageOpen && (
              <ul className="absolute z-10 mt-2 w-full bg-white border border-blueThinDobule rounded-lg shadow-md max-h-60 overflow-auto border-b-[4px] border-b-[#00C3FF]">
                {[
                  { id: 'en', name: 'English' },
                  { id: 'hi', name: 'हिंदी' },
                ].map((lang) => (
                  <li
                    key={lang.id}
                    onClick={() => { setSelectedLanguage(lang.id); setIsLanguageOpen(false); }}
                    className={`px-4 py-2 m-2 cursor-pointer hover:bg-blue-50 border-b ${selectedLanguage === lang.id ? 'bg-lightThinBlue text-customBlue font-semibold' : 'text-gray-700 '}`}
                  >
                    {lang.name}
                  </li>
                ))}
              </ul>
              )}
            </div>
          </div>
          )
        } */}
        {initialCourseGroupData?.name && (
          <CourseSection
            heading={initialCourseGroupData?.name}
            content={initialCourseGroupData?.description}
            entityId={initialCourseGroupData?.id}
            entityType="course-group"
            brochureLink={initialCourseGroupData?.brochure}
            syllabusLink={initialCourseGroupData?.metaFilter?.syllabus}
          />
        )}
        {/* Section 0: render batch or course carousel based on listType */}
        {initialCourseGroupData?.courseGroupSections[0]
          && (initialCourseGroupData?.courseGroupSections[0]?.listType
          === 'batch' ? (
            <CourseBatchSection
              title={initialCourseGroupData?.meta?.titleMeta?.batch?.title}
              sectionTitle={initialCourseGroupData?.courseGroupSections[0].title}
              subtitle={initialCourseGroupData?.meta?.titleMeta?.batch?.subTitle}
              courses={
                initialCourseGroupData?.courseGroupSections[0]?.batches || []
              }
              notes={initialCourseGroupData?.courseGroupSections[0]?.notes}
              combos={initialCourseGroupData?.courseGroupSections[0]?.combos || []}
              filterList={
                initialCourseGroupData?.courseGroupSections[0]?.pageFilters
              }
              tagList={
                initialCourseGroupData?.courseGroupSections[0]?.tagList
              }
              sectionId={
                initialCourseGroupData?.courseGroupSections[0]?.sectionId
              }
              courseGroupId={initialCourseGroupData?.id}
              className="py-10"
            />
            ) : (
              <CourseTestSection
                courses={initialCourseGroupData?.courseGroupSections[0]?.courses}
                title={initialCourseGroupData?.meta?.titleMeta?.batch?.title}
                subtitle={initialCourseGroupData?.courseGroupSections[0].title}
                pageType="course"
                domainName="/home"
                typeClasses="name"
              />
            ))}

        {/* Section 1: render batch or course carousel based on listType */}
        {initialCourseGroupData?.courseGroupSections[1]
          && (initialCourseGroupData?.courseGroupSections[1]?.listType
          === 'batch' ? (
            <CourseBatchSection
              title={
                initialCourseGroupData?.courseGroupSections[0]
                  ? ''
                  : initialCourseGroupData?.meta?.titleMeta?.batch?.title
              }
              sectionTitle={initialCourseGroupData?.courseGroupSections[1].title}
              subtitle={
                initialCourseGroupData?.courseGroupSections[0]
                  ? ''
                  : initialCourseGroupData?.meta?.titleMeta?.batch?.subTitle
              }
              courses={
                initialCourseGroupData?.courseGroupSections[1]?.batches || []
              }
              notes={initialCourseGroupData?.courseGroupSections[1]?.notes}
              combos={initialCourseGroupData?.courseGroupSections[1]?.combos || []}
              filterList={
                initialCourseGroupData?.courseGroupSections[1]?.pageFilters
              }
              tagList={
                initialCourseGroupData?.courseGroupSections[0]?.tagList
              }
              sectionId={
                initialCourseGroupData?.courseGroupSections[1]?.sectionId
              }
              courseGroupId={initialCourseGroupData?.id}
              className={`pb-10 ${
                initialCourseGroupData?.courseGroupSections[0] ? 'mt-1 pt-2' : ''
              }`}
            />
            ) : (
              <CourseTestSection
                courses={initialCourseGroupData?.courseGroupSections[1]?.courses}
                title={
                initialCourseGroupData?.courseGroupSections[0]
                  ? ''
                  : initialCourseGroupData?.meta?.titleMeta?.batch?.title
              }
                subtitle={initialCourseGroupData?.courseGroupSections[1].title}
                pageType="course"
                domainName="/home"
                typeClasses="name"
              />
            ))}
        {initialCourseGroupData?.meta?.bodyHtml && (
          <CourseSpecifications
            content={initialCourseGroupData?.meta?.bodyHtml}
            title={
              initialCourseGroupData?.meta?.titleMeta?.course_specification
                ?.title
            }
            subtitle={initialCourseGroupData?.meta?.titleMeta?.course_specification?.subTitle}
          />
        )}
        {contentBlocks.filter((block) => block?.slotName === 'slot1' || block?.slotName === 'slot2' || block?.slotName === 'slot3').map((block) => (
          <div key={block?.slotName} className="w-full">
            <div dangerouslySetInnerHTML={{ __html: block?.content }} />
          </div>
        ))}
        {initialCourseGroupData?.features.length > 0 && (
          <CourseFeatures
            courseFeatures={initialCourseGroupData?.features}
            heading={
              initialCourseGroupData?.meta?.titleMeta?.course_features?.title
            }
            subheading={
              initialCourseGroupData?.meta?.titleMeta?.course_features?.subTitle
            }
          />
        )}
        {initialCourseGroupData?.demoVideos.length > 0 && (
          <CarouselSection
            title={initialCourseGroupData?.meta?.titleMeta?.demo_videos?.title}
            subtitle={
              initialCourseGroupData?.meta?.titleMeta?.demo_videos?.subTitle
            }
            data={initialCourseGroupData?.demoVideos}
            type="video"
          />
        )}
        {/* {initialCourseGroupData?.recommendedCourses.length > 0 && (
          <CarouselSection
            title={
              initialCourseGroupData?.meta?.titleMeta?.recommended_courses
                ?.title
            }
            subtitle={
              initialCourseGroupData?.meta?.titleMeta?.recommended_courses
                ?.subTitle
            }
            data={initialCourseGroupData?.recommendedCourses}
            type="course"
          />
        )} */}
        {contentBlocks.filter((block) => block?.slotName === 'slot4')[0] && (
        <div className="w-full">
          <div dangerouslySetInnerHTML={{ __html: contentBlocks.filter((block) => block?.slotName === 'slot4')[0]?.content }} />
        </div>
        )}
        {initialCourseGroupData?.testimonials.length > 0 && (
          <TestimonialSection
            testimonials={initialCourseGroupData?.testimonials}
            heading={
              initialCourseGroupData?.meta?.titleMeta?.testimonials?.title
            }
            subheading={
              initialCourseGroupData?.meta?.titleMeta?.testimonials?.subTitle
            }
          />
        )}
        {initialCourseGroupData?.faqs.length > 0 && (
          <FAQSectionMinimal
            faqs={initialCourseGroupData?.faqs}
            title={initialCourseGroupData?.meta?.titleMeta?.faqs?.title}
            subtitle={initialCourseGroupData?.meta?.titleMeta?.faqs?.subTitle}
          />
        )}
        {contentBlocks.filter((block) => block?.slotName === 'slot5')[0] && (
        <div className="w-full">
          <div dangerouslySetInnerHTML={{ __html: contentBlocks.filter((block) => block?.slotName === 'slot5')[0]?.content }} />
        </div>
        )}
      </div>
    </div>
  );
}

CourseLanding.propTypes = {
  initialCourseGroupData: PropTypes.object.isRequired,
};

export default CourseLanding;
